/**
 * Component Registry for Woodside Place Apartments
 * 
 * Inherits from @vibesites-dietz-property-group/theme-preferred and allows property-specific overrides.
 */

import type { ComponentRegistry } from '@vibesites/runtime';
import { registry as parentRegistry } from '@vibesites-dietz-property-group/theme-preferred/registry';
import { NudgeCTA } from './components/NudgeCTA';
import { Footer } from './components/Footer';
import { ContactUs } from './components/ContactUs';
import { Header } from './components/Header';
import { PageBlurb } from './components/PageBlurb';
import { PropertyOverview } from './components/PropertyOverview';
import { NeighborhoodCallout } from './components/NeighborhoodCallout';

/**
 * Property-specific component overrides.
 * Uncomment and customize components as needed.
 */
const propertyOverrides: Partial<ComponentRegistry> = {
  NudgeCTA,
  // Footer: adds an "appointment" richtext note below the office hours column.
  Footer,
  // ContactUs: adds an "appointment" richtext note below office hours in the contact info cards.
  ContactUs,
  // Header: adds an "appointment" richtext note below office hours in the hamburger menu.
  Header,
  // PageBlurb: normalizes pasted inline styles so blurbs always render in the theme's blurb style.
  PageBlurb,
  // PropertyOverview: normalizes pasted inline styles on the description so it renders in the theme's overview style.
  PropertyOverview,
  // NeighborhoodCallout: normalizes pasted inline styles on the description so it renders in the theme's neighborhood style.
  NeighborhoodCallout,
};

/**
 * Final merged registry for this property.
 * Inherits all components from the parent theme, with property overrides.
 */
export const registry: ComponentRegistry = {
  ...parentRegistry,
  ...propertyOverrides,
};

export default registry;
